<template>
  <div class="filter-container">
    <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="125px">
      <el-form-item label="索赔后台数据单号">
        <el-input
          v-model="searchForm.presetDataId"
          placeholder="请输入索赔后台数据单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="关联客户账号">
        <el-input
          v-model="searchForm.customerAccountNum"
          placeholder="请输入关联客户账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="国家">
        <el-select
          filterable
          clearable
          v-model="searchForm.customerCountry"
          placeholder="请选择国家"
        >
          <el-option
            v-for="item in nationList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公司">
        <el-input
          v-model="searchForm.customerCompanyName"
          placeholder="请输入公司"
        ></el-input>
      </el-form-item>
      <el-form-item label="结算币种">
        <el-select v-model="searchForm.currency" filterable clearable placeholder="请选择结算币种">
          <el-option label="CNY" value="0"> </el-option>
          <el-option label="USD" value="1"> </el-option>
          <el-option label="RUB" value="2"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          filterable
          v-model="searchForm.status"
          clearable
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
        <el-button
          type="primary"
          @click="handleSearch"
          >查询</el-button
        >
        <el-button type="primary" plain @click="handleResetQuery"
          >重置</el-button
        >
  
    </el-form>
  </div>
</template>
<script>
import { getSession } from "@/util/localStor";
export default {
  data() {
    return {
      searchForm: {
        presetDataId: "",
        customerAccountNum: "",
        customerCountry: "",
        customerCompanyName: "",
        currency: "",
        status: ""
      },
      nationList: [],
      statusList: [
        { id: 0, name: "未启用" },
        { id: 1, name: "已启用" },
        { id: 2, name: "已作废" },
        { id: 3, name: "已过期" }
      ]
    };
  },
  mounted() {
    this.nationList = Object.values(getSession("nationList"));
  },
  methods: {
    // 搜索
    handleSearch() {
      this.$emit("handleSearch", this.searchForm);
    },
    // 重置查询条件
    handleResetQuery() {
      this.searchForm = Object.assign({}, this.$options.data()?.searchForm);
      this.handleSearch();
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<!-- <style lang="scss" scoped>
.search {
  padding: 0 60px;
  margin-top: 15px;
  border-bottom: 5px solid #efefef;
  padding-right: 60px;
  ::v-deep .el-input {
    width: 200px;
  }
}
</style> -->
